<template>
  <div class="wrap talk">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section class="txt tit">
            <h1>주의사항 안내</h1>
          </section>
          <section>
            <div class="box privacy">
              <ul>
                <li>커넥터 미설치 고객님은 액정불량 또는 예전 모델로 매입 단가가 매우 낮습니다.</li>
                <li>사진 업로드 후 운송장 번호를 미입력 또는 오입력 하시면 검수결과가 지연될 수 있습니다.</li>
                <li>추가보상 대상자 확인을 위하여 본인인증이 필수입니다.</li>
              </ul>
            </div>
          </section>
          <div class="btn-wrap">
            <a href="javascript:void(0);" class="talk-btn btn-black" @click="goCertPass()">본인인증 하러 가기</a>
          </div>
        </article>
      </main>
    </div>
  </div>
</template>

<script>

import Vue from "vue";

export default {
  name: 'NonfunctionalNotice',
  components: {
  },
  data: () => ({
    params:{
      pass_type: '3',
      tmpCrtfSersNum: ''
    }
  }),
  computed: {
  },
  created () {
  },
  mounted () {
    this.params.tmpCrtfSersNum = this.$route.query.tmpCrtfSersNum.replace('%20','').replace(' ', '')
  },
  watch: {
  },
  methods: {
    async goCertPass() {
      const rtn = await Vue.httpClient
        .post('/api/purchase/public/nice/cert/nonfunctional', {...this.$route.query, ...this.params})
        .then(res => {
          if (res.data && res.data.result) {
            const rs = res.data.result;
            console.log(rs);
            if ('success' === rs.msg) {
              const param = {};
              let tmpStrs = [];
              console.log(rs.cert_pass_url)
              if (rs.cert_pass_url) {
                if (rs.cert_pass_url.indexOf('?') > 0) {
                  const k = rs.cert_pass_url.substring(rs.cert_pass_url.indexOf('?') + 1).split('&');
                  for (let i in k) {
                    tmpStrs = k[i].split('=');
                    param[tmpStrs[0]] = tmpStrs[1]
                  }
                }
              }
              this.$router.push({name: 'CrtfPass', query: {...this.$route.query, ...param}})
            }
          }
        });
    }
  }
}
</script>

<style scoped>
  h1.notice-sale-nonfunctional{ padding-top: 30%; padding-left: 10%; }
  ul { margin: 3vh auto; }
  ul>li { width: 80vw; margin: 1vh auto; list-style-type: disc;}
  .certification .txt {height: 12.75rem; }
</style>



// WEBPACK FOOTER //
// src/views/purchase/sale/nonfunctional/Notice.vue